import React from "react";


function isValidCandidateGPS(value) {
  if (typeof value !== "string") return false;

  const parts = value.split(",").map((p) => p.trim());

  if (
    parts.length !== 2 ||
    parts.some((p) =>
      !/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(p)
    )
  ) {
    return false;
  }

  const latitude = Number(parts[0]);
  const longitude = Number(parts[1]);

  return (
    Number.isFinite(latitude) &&
    Number.isFinite(longitude) &&
    Math.abs(latitude) <= 90 &&
    Math.abs(longitude) <= 180 &&
    !(latitude === 0 && longitude === 0)
  );
}

function GoogleGeoProposalContent({ place, onSelect }) {
  const p = place?.aiGeocode?.proposedLocation;
  const isConfirmed =
    p?.reviewStatus === "CONFIRMED_BY_DISPATCHER";

  const selectedCoordinates =
    String(p?.coordinates || "").replace(/\s+/g, "");

  const isSelected = (option) =>
    Boolean(selectedCoordinates) &&
    selectedCoordinates ===
      String(option?.coordinates || "").replace(/\s+/g, "") &&
    String(p?.name || "") === String(option?.name || "");

  const options =
    Array.isArray(place?.aiGeocode?.candidateOptions)
      ? place.aiGeocode.candidateOptions
      : [];

  if (options.length > 0) {
    return (
      <details open style={{ marginTop: 5, marginBottom: 6 }}>
        <summary style={{
          cursor: "pointer",
          color: "#e4b85b",
          fontSize: 11,
          width: "fit-content"
        }}>
          {p ? "Por confirmar · Alterar localização" :
            `${options.length} localizações possíveis`}
        </summary>
        <div style={{ padding: 8 }}>
          {options.map((option, i) => (
            <button
              type="button"
              key={option.coordinates + i}
              disabled={!isValidCandidateGPS(option?.coordinates)}
              title={
                isValidCandidateGPS(option?.coordinates)
                  ? undefined
                  : "Sem coordenadas GPS válidas"
              }
              onClick={() => {
                if (isValidCandidateGPS(option?.coordinates)) {
                  onSelect?.(option);
                }
              }}
              style={{
                display: "block",
                width: "100%",
                textAlign: "left",
                padding: 8,
                marginBottom: 5,
                cursor: "pointer",
                borderRadius: 6,
                border: isSelected(option)
                  ? "1px solid #4c9aff"
                  : "1px solid #60646d",
                background: isSelected(option)
                  ? "rgba(47, 117, 225, 0.28)"
                  : "#51545b",
                color: "#ffffff",
                fontFamily: "inherit",
                transition: "background 0.15s, border 0.15s"
              }}
              aria-pressed={isSelected(option)}
            >
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 8
              }}>
                <strong>{option.name}</strong>
                {isSelected(option) && (
                  <span style={{
                    color: "#91c4ff",
                    fontSize: 11,
                    fontWeight: 600,
                    whiteSpace: "nowrap"
                  }}>
                    ✓ Selecionado
                  </span>
                )}
              </div>
              <div style={{ fontSize: 11 }}>
                {option.resolvedAddress}
                  <div>GPS: {option.coordinates || "Indisponível"}</div>
                  <div>Score: {option.score ?? "N/D"}</div>
                  <div>Conflitos: {
                    Array.isArray(option.conflicts) &&
                    option.conflicts.length > 0
                      ? option.conflicts.join(", ")
                      : "Nenhum identificado"
                  }</div>
              </div>
            </button>
          ))}
          <small>GPS sujeito a confirmação.</small>
        </div>
      </details>
    );
  }


  const suggestions =
    Array.isArray(place?.aiGeocode?.suggestionOptions)
      ? place.aiGeocode.suggestionOptions
      : [];

  if (suggestions.length > 0) {
    return (
      <details open style={{ marginTop: 5, marginBottom: 6 }}>
        <summary style={{
          cursor: "pointer",
          fontSize: 11,
          color: "#e4b85b",
          width: "fit-content"
        }}>
          {"Localizações encontradas · " + suggestions.length +
            (isConfirmed ? " · GPS confirmado (alterável)" : " · comparar e confirmar")}
        </summary>

        <div style={{
          marginTop: 6,
          padding: 9,
          border: "1px solid #b58b38",
          borderRadius: 6,
          fontSize: 12
        }}>
          <div style={{ marginBottom: 7 }}>
            {isConfirmed
              ? "GPS confirmado. Podes comparar e escolher outra localização."
              : "GPS em análise. Nenhuma sugestão é aceite sem confirmação."}
          </div>

          {suggestions.map((item, index) => {
            const values = String(item.coordinates || "")
              .split(",").map(Number);

            const valid = values.length === 2 &&
              Number.isFinite(values[0]) &&
              Number.isFinite(values[1]) &&
              Math.abs(values[0]) <= 90 &&
              Math.abs(values[1]) <= 180;

            const url = valid
              ? "https://www.google.com/maps/search/?api=1&query=" +
                encodeURIComponent(item.coordinates)
              : null;

            return (
              <div key={index} style={{
                padding: 8,
                marginBottom: 6,
                border: isSelected(item)
                  ? "1px solid #4c9aff"
                  : "1px solid #666",
                background: isSelected(item)
                  ? "rgba(47,117,225,0.28)"
                  : "transparent",
                borderRadius: 6
              }}>
                <strong>{item.name}</strong>
                <div>{item.resolvedAddress || ""}</div>
                <div>GPS sugerido: {item.coordinates}</div>
                <div style={{ color: "#e4b85b" }}>
                  {(item.conflicts || []).join(", ") ||
                    "Evidência insuficiente"}
                </div>
                {url && (
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={event => event.stopPropagation()}
                    style={{
                      display: "inline-block",
                      marginTop: 8,
                      padding: "7px 10px",
                      borderRadius: 6,
                      background: "#244b82",
                      border: "1px solid #4c9aff",
                      color: "#ffffff",
                      textDecoration: "none",
                      cursor: "pointer",
                      pointerEvents: "auto",
                      fontWeight: 600
                    }}
                  >
                    Abrir no Google Maps ↗
                  </a>
                )}
                <button
                  type="button"
                  disabled={!valid}
                  onClick={() => onSelect?.(item)}
                  style={{
                    display: "block",
                    marginTop: 9,
                    padding: "7px 10px",
                    borderRadius: 6,
                    background: "#244b82",
                    color: "#fff",
                    border: "1px solid #4c9aff",
                    cursor: valid ? "pointer" : "not-allowed",
                    fontSize: 11,
                    fontFamily: "inherit"
                  }}
                >
                  {isSelected(item)
                    ? (isConfirmed
                        ? "✓ GPS confirmado · Alterável"
                        : "✓ Em análise · Por confirmar")
                    : "Usar GPS como proposta"}
                </button>
              </div>
            );
          })}
          <small>
            Sugestões para análise. Não são
            coordenadas operacionais.
          </small>
        </div>
      </details>
    );
  }

  if (!p || p.reviewStatus === "CONFIRMED_BY_DISPATCHER") {
    return null;
  }

  const coords = String(p.coordinates || "").trim();
  const parts = coords.split(",").map(Number);

  if (
    parts.length !== 2 ||
    !Number.isFinite(parts[0]) ||
    !Number.isFinite(parts[1]) ||
    Math.abs(parts[0]) > 90 ||
    Math.abs(parts[1]) > 180
  ) return null;

  const url = "https://www.google.com/maps?q=" +
    encodeURIComponent(coords);

  return (
    <details data-testid="google-geo-proposal"
      style={{ marginTop: 5, marginBottom: 5 }}>
      <summary style={{
        display: "list-item",
        width: "fit-content",
        cursor: "pointer",
        fontSize: 11,
        color: "#805c00",
        background: "#fff5d6",
        border: "1px solid #e8d494",
        borderRadius: 6,
        padding: "3px 7px"
      }}>
        Por confirmar
      </summary>

      <div style={{
        fontSize: 12,
        padding: 9,
        marginTop: 5,
        background: "#fffaf0",
        borderRadius: 6
      }}>
        <div>{p.displayName || p.name || ""}</div>
        <div>{p.resolvedAddress || ""}</div>
        <div>{(p.conflicts || []).join(", ")}</div>
        <a href={url} target="_blank"
          rel="noopener noreferrer">
          Ver no Google Maps
        </a>

      </div>
    </details>
  );
}


/*
 * Explicit dispatcher confirmation.
 *
 * Selecting a candidate must not populate operational GPS.
 * Only the user's confirmation invokes onConfirm.
 */
export default function GoogleGeoProposal({
  place,
  onSelect,
  onConfirm
}) {
  const proposed =
    place?.aiGeocode?.proposedLocation;

  const coordinates =
    String(proposed?.coordinates || "").trim();

  const parts =
    coordinates.split(",").map(value => Number(value.trim()));

  const validCoordinates =
    parts.length === 2 &&
    coordinates.split(",").every(value => value.trim() !== "") &&
    parts.every(Number.isFinite) &&
    Math.abs(parts[0]) <= 90 &&
    Math.abs(parts[1]) <= 180 &&
    !(parts[0] === 0 && parts[1] === 0);

  const canConfirm =
    proposed?.reviewStatus === "PENDING" &&
    validCoordinates &&
    typeof onConfirm === "function";

  const mapsUrl =
    "https://www.google.com/maps?q=" +
    encodeURIComponent(coordinates);

  return (
    <>
      <GoogleGeoProposalContent
        place={place}
        onSelect={onSelect}
      />

      {canConfirm && (
        <div
          data-testid="google-geo-manual-confirmation"
          style={{
            marginTop: 8,
            marginBottom: 10,
            padding: 12,
            border: "1px solid #c89a3c",
            borderRadius: 8,
            background: "#fff8e7",
            color: "#332b1d",
            fontSize: 12
          }}
        >
          <strong>
            Localização selecionada — por confirmar
          </strong>

          <div style={{ marginTop: 6 }}>
            {proposed.name || proposed.displayName ||
              "Localização proposta"}
          </div>

          <div style={{ marginTop: 4 }}>
            {proposed.resolvedAddress || ""}
          </div>

          <div style={{ marginTop: 4 }}>
            GPS: {coordinates}
          </div>

          {Array.isArray(proposed.conflicts) &&
            proposed.conflicts.length > 0 && (
              <div style={{
                marginTop: 6,
                color: "#915b10"
              }}>
                Atenção: {proposed.conflicts.join(", ")}
              </div>
            )}

          <div style={{ marginTop: 8 }}>
            <a
              href={mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Abrir no Google Maps ↗
            </a>
          </div>

          <button
            type="button"
            data-testid="confirm-google-geo-button"
            onClick={() => onConfirm(proposed)}
            style={{
              marginTop: 10,
              padding: "9px 12px",
              cursor: "pointer",
              borderRadius: 6,
              border: "1px solid #236345",
              background: "#236345",
              color: "#ffffff",
              fontWeight: 600
            }}
          >
            Confirmar manualmente este GPS
          </button>

          <div style={{
            marginTop: 7,
            fontSize: 11
          }}>
            As coordenadas só serão utilizadas
            depois desta confirmação.
          </div>
        </div>
      )}
    </>
  );
}
